import { render, staticRenderFns } from "./ActionForm.vue?vue&type=template&id=88c87668"
import script from "./ActionForm.vue?vue&type=script&lang=js"
export * from "./ActionForm.vue?vue&type=script&lang=js"
import style0 from "./ActionForm.vue?vue&type=style&index=0&id=88c87668&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports